import React from 'react';
import styled from 'styled-components';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import { fadeIn, fadeOut } from '../../DesignSystem/design-system';
import { zIndex } from '../../DesignSystem/zIndex';
const BACKDROP_CLOSE_DURATION = 300;
const BACKDROP_OPEN_DURATION = 300;
const BACKDROP_COLOR = 'rgba(0, 0, 0, 0.2)';
const Backdrop = styled(ImpContainer) `
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${BACKDROP_COLOR};
  display: ${({ isOpen, isClosing }) => isOpen || isClosing ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;

  z-index: ${zIndex.backdrop};

  animation: ${({ isClosing }) => (isClosing ? fadeOut : fadeIn)}
    ${({ isClosing }) => isClosing
    ? `${BACKDROP_CLOSE_DURATION}ms`
    : `${BACKDROP_OPEN_DURATION}ms`}
    ease-in-out;
`;
export default function ImpBackdrop({ children, isOpen, isClosing, onClick, }) {
    return (React.createElement(Backdrop, { dataTestId: "backdrop", isOpen: isOpen, isClosing: isClosing, onClick: onClick },
        React.createElement(ImpContainer, { dataTestId: "backdrop-content", cursor: "auto" }, children)));
}
//# sourceMappingURL=ImpBackdrop.js.map